// cms_tech.js is responsible for communicating with the CMS Tech parent frame.
// It has no dependencies.

export function cmsTechGetWorkOrderQuery() {
    var msg_type = "get_workorders";
    parent.postMessage(
        {
         msgType: msg_type,  // AWH delete?
         msg_type: msg_type,
        }, "*")
}


function __cmsTechNewFeature(id_floor, coord, p1p2, msg_type)
{
    var msg =         {
        idLocation: id_floor,
        xCoord: coord[0],
        yCoord: coord[1],
        p1xCoord:p1p2[0][0],
        p1yCoord:p1p2[0][1],
        p2xCoord:p1p2[1][0],
        p2yCoord:p1p2[1][1],
        msgType: msg_type,     // AWH delete?
        msg_type: msg_type,  
        
    }

    console.error(`posting message ${JSON.stringify(msg)} AWH DELETE`)  // AWH DELETE
    parent.postMessage(msg, "*")

}

function cmsTechNewAsset(id_floor, coord, p1p2) {
    __cmsTechNewFeature(id_floor, coord, p1p2, "new_asset")
}

export function cmsTechNewFinding(id_floor, coord, p1p2) {
    __cmsTechNewFeature(id_floor, coord, p1p2, "new_finding")
}

function cmsTechNewWorkOrder(id_floor, coord, p1p2) {
    __cmsTechNewFeature(id_floor, coord, p1p2, "new_workorder")
}



// WEBPACK FOOTER //
// ./js/cms_tech.js